module.exports = __webpack_public_path__ + "static/img/id_card_1.6feb1b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/id_card_1.png
// module id = ZViN
// module chunks = 1